<script lang="ts">
	import type { Post } from '$lib/api/rpc';
	import OptionsMenu from '$lib/components/Post/OptionsMenu/OptionsMenu.svelte';
	import Wrapper from '$lib/components/Post/Tile/Wrapper.svelte';
	import { setPostContextStore } from '$lib/components/Post/postContextStore';
	import { getHubStores } from '$lib/stores/hubStores';
	import { getQuickPollURL } from '$lib/utils/getQuickPollURL';
	import { atLeastModerator } from '$lib/utils/roles';

	const { hub, user } = getHubStores();

	export let post: Post;
	export let postIndex: number;

	setPostContextStore(post);

	$: embedHTML = post.etc.widget?.html ? post.etc.widget.html : '';
	$: embedURL = post.etc.widget?.url ? post.etc.widget.url : '';
	$: embedImg = post.title_image?.url ? post.title_image.url : '';
	$: quickPollURL = getQuickPollURL({
		quickPollUrl: post.etc.widget?.url,
		hub: $hub,
		user: $user,
	});

	const optionsMenuPerms = {
		edit: true,
		settings: false,
		performance: false,
		feature: false,
		pin: true,
		hide: true,
		exportImages: false,
		exportComments: false,
		delete: true,
	};

	let iframeEl: HTMLIFrameElement;

	const injectCSS = () => {
		const document = iframeEl?.contentWindow?.document;

		if (document) {
			const html = document.getElementsByTagName('html')[0];
			const body = html.getElementsByTagName('body')[0];
			html.style.height = '100%';
			body.style.height = '100%';
			body.style.margin = '0';

			const nestedIframeEl = body.getElementsByTagName('iframe')[0];

			let nestedDocument;
			try {
				nestedDocument = nestedIframeEl?.contentWindow?.document;
			} catch (_) {
				return;
			}

			if (nestedDocument) {
				const html = nestedDocument.getElementsByTagName('html')[0];
				const body = html.getElementsByTagName('body')[0];
				html.style.height = '100%';
				html.style.width = '100%';
				body.style.height = '100%';
				body.style.width = '100%';
				body.style.margin = '0';
				nestedIframeEl.style.height = '100%';
				nestedIframeEl.style.width = '100%';
			}
		}
	};
</script>

<Wrapper>
	<div class="container">
		{#if atLeastModerator($hub.user_context)}
			<div class="optionMenu">
				<OptionsMenu parent="collectionPage" permissions={optionsMenuPerms} {postIndex} />
			</div>
		{/if}
		{#if post.type === 'widgetHtml'}
			<iframe srcdoc={embedHTML} title="Widget" on:load={injectCSS} bind:this={iframeEl} />
		{:else if post.type === 'widgetQuickPoll'}
			<iframe src={quickPollURL} title="QuickPoll" />
		{:else}
			<a href={embedURL}>
				<div class="img" style={`background: url("${embedImg}") no-repeat center`} />
			</a>
		{/if}
	</div>
</Wrapper>

<style>
	.container {
		position: relative;
		block-size: 543px;
	}

	.container :global(iframe) {
		block-size: 100%;
		inline-size: 100%;
		border: none;
	}

	.img {
		block-size: 100%;
		inline-size: 100%;
	}

	.optionMenu {
		display: flex;
		position: absolute;
		z-index: 1;
		align-items: center;
		justify-content: center;
		block-size: 35px;
		inline-size: 35px;
		border-radius: 50%;
		background-color: white;
		inset-block-start: 10px;
		inset-inline-end: 10px;
		box-shadow: var(--contentShadowHover);
	}
</style>
